import Storage from "./common/storage.es6";
import Animation from "./top/animation.es6";
import Movie from "./top/movie.es6";
import Banner from "./top/banner.es6";

class Top {
    constructor() {
        window.STORAGE = new Storage();
        this.animation = new Animation();
        this.movie = new Movie();
        this.banner = new Banner();
    }
}

const top = new Top();
